export default __webpack_public_path__ + "static/media/cetGentleCleanser.9ba2426d.png";